import ActionButton from '../../../Buttons/ActionButton';
import POSBrandFilterCard from './POSBrandFilterCard';
import POSCategoryFilterCard from './POSCategoryFilterCard';
import POSPriceFilterCard from './POSPriceFilterCard';
import POSSubCategoryFilterCard from './POSSubCategoryFilterCard';

interface POSProductFilterContentProps {
  priceMax: number;

  selectedCategoryName?: string;

  selectedSubCategoryName?: string;

  selectedBrandName?: string;

  setShowPriceModal: (open: boolean) => void;

  setShowCategoryModal: (open: boolean) => void;

  setShowSubCategoryModal: (open: boolean) => void;

  setShowBrandModal: (open: boolean) => void;

  handleApplyFilters: () => void;

  handleClearFilters: () => void;

  isSaleInitialized: boolean;
}

const POSProductFilterContent: React.FC<POSProductFilterContentProps> = ({
  priceMax,

  selectedCategoryName,

  selectedSubCategoryName,

  selectedBrandName,

  setShowPriceModal,

  setShowCategoryModal,

  setShowSubCategoryModal,

  setShowBrandModal,

  handleApplyFilters,

  handleClearFilters,

  isSaleInitialized,
}) => {
  return (
    <div className="flex flex-col gap-3">
      {/* ===================================================== */}
      {/* 🔹 Header */}
      {/* ===================================================== */}

      <div>
        <h3
          className="
            text-sm
            font-semibold
            text-black

            dark:text-white
          "
        >
          Filtros
        </h3>

        <p
          className="
            mt-1
            text-xs
            text-body
          "
        >
          Configura filtros rápidos para los productos.
        </p>
      </div>

      {/* ===================================================== */}
      {/* 🔹 Category */}
      {/* ===================================================== */}

      <POSCategoryFilterCard
        disabled={!isSaleInitialized}
        selectedCategoryName={selectedCategoryName}
        onClick={() => setShowCategoryModal(true)}
      />

      {/* ===================================================== */}
      {/* 🔹 Sub Category */}
      {/* ===================================================== */}

      <POSSubCategoryFilterCard
        disabled={!isSaleInitialized}
        selectedSubCategoryName={selectedSubCategoryName}
        onClick={() => setShowSubCategoryModal(true)}
      />

      {/* ===================================================== */}
      {/* 🔹 Brand */}
      {/* ===================================================== */}

      <POSBrandFilterCard
        disabled={!isSaleInitialized}
        selectedBrandName={selectedBrandName}
        onClick={() => setShowBrandModal(true)}
      />

      {/* ===================================================== */}
      {/* 🔹 Price */}
      {/* ===================================================== */}

      <POSPriceFilterCard
        priceMax={priceMax}
        disabled={!isSaleInitialized}
        onClick={() => setShowPriceModal(true)}
      />

      {/* ===================================================== */}
      {/* 🔹 Actions */}
      {/* ===================================================== */}

      <div className="flex gap-2">
        <ActionButton
          label="Limpiar"
          disabled={!isSaleInitialized}
          onClick={handleClearFilters}
          variant="secondary"
        />

        <ActionButton
          label="Aplicar"
          disabled={!isSaleInitialized}
          onClick={handleApplyFilters}
          variant="primary"
        />
      </div>
    </div>
  );
};

export default POSProductFilterContent;
